export default __webpack_public_path__ + "static/Ship correctly-a7beedfd24014ff7284f2c7e7b4f3e7e.png";